import {toCurrency, toPoints} from '@/shared/helpers'
import { useMemo } from 'react';
export const TABLE_COLUMNS = [
  {
    Header: "Event",
    accessor: "event_name",
  },
  {
    Header: "GL Code",
    accessor: "ledger_code",
  },
  {
    Header: "Date",
    accessor: "posting_timestamp",
  },
  {
    id: 'to',
    Header: () => (<div style={{textAlign: 'center', borderTop: '1px solid #ccc', paddingTop: 6}}>To</div>),
    className: 'align-center',
    Footer: "",
    columns: [
      {
        Header: "Employee ID",
        accessor: "employee_number",
        width: 100
      },
      {
        Header: "First Name",
        accessor: "recipient_first_name",
        width: 100
      },
      {
        Header: "Last Name",
        accessor: "recipient_last_name",
        width: 100
      },
      {
        Header: "Email",
        accessor: "recipient_email",
      }
    ]
  },
  {
    Header: "From",
    accessor: data => (
      data.awarder_full
    ),
    width: 120
  },
  {
    Header: "Approved By",
    accessor: data => (
      data.action_by_name
    ),
    width: 120
  },
  {
    Header: "Referrer",
    accessor: "referrer",
  },
  {
    Header: "Notes",
    accessor: "notes",
    Footer: "Total"
  },
  {
    Header: "Dollar Value",
    accessor: "dollar_value",
    Cell: ({ row, value }) => { return toCurrency(value); },
    width: 110,
    Footer:  () => null
  },
   {
    Header: "Award Message",
    accessor: "notification_body",
    width: 200,
    Cell: ({ value }) => (
        <div
            className="award-message-cell"
            dangerouslySetInnerHTML={{ __html: value }}
        />
    ),
  },
];
